import {Component, HostBinding, OnDestroy, OnInit} from '@angular/core';
import {routeAnimation} from '../../../../route.animation';
import {FormBuilder, Validators} from '@angular/forms';
import {FormsService} from '../../../../_services/forms.service';
import {ClientsService} from '../../../../_services/clients.service';
import {Subscription} from 'rxjs/Subscription';
import {ActivatedRoute, Params} from '@angular/router';
import {ClientsContactsPersons} from '../../../../_interfaces/clients/clients-contacts-persons';
import {PreviousUrlService} from '../../../../_services/previous-url.service';
import {ApiService} from '../../../../_interceptors/api.service';
import {PageTitleService} from '../../../../_services/page-title.service';
import {environment} from '../../../../../environments/environment';
import {Client} from '../../../../_interfaces/clients/clients';

@Component({
	selector: 'app-clients-contact-persons-edit',
	templateUrl: './clients-contacts-persons-edit.component.html',
	styleUrls: ['./clients-contacts-persons-edit.component.scss'],
	animations: [routeAnimation]
})

export class ClientsContactPersonsEditComponent implements OnInit, OnDestroy {

	@HostBinding('@routeAnimation') routerTransition = true;

	public client_id: number = null;
	public contact_person_id: number = null;
	public dataLoaded: boolean = false;
	public missingData: Array<string> = [];

	public clientContactPersonsEditForm = this.formBuilder.group({
		firstname: ['', [Validators.required, Validators.maxLength(50)]],
		lastname: ['', [Validators.required, Validators.maxLength(50)]],
		telephone: ['', Validators.maxLength(20)],
		email: ['', [Validators.required, Validators.email]],
		mobile: ['']
	});

	private _activatedRouteSubscription: Subscription = null;
	private _errorsSubscription: Subscription = null;

	constructor(public formsService: FormsService,
				private formBuilder: FormBuilder,
				private activatedRoute: ActivatedRoute,
				private previousUrlService: PreviousUrlService,
				private apiService: ApiService,
				public clientsService: ClientsService,
				private pageTitleService: PageTitleService) {
	}

	ngOnInit(): void {
		this.apiService.connectionChanged.subscribe(online => {
			if (online && this.missingData.length > 0) {
				this.missingData = [];
				this.loadData();
			}
		});

		this.formsService.form = this.clientContactPersonsEditForm;

		this._activatedRouteSubscription = this.activatedRoute.params.subscribe((params: Params) => {
			this.client_id = parseInt(params['client_id'], 10);
			this.contact_person_id = parseInt(params['contact_person_id'], 10);

			this.clientsService.getClient(this.client_id).then((client: Client) => {
				if (typeof client !== 'undefined') {
					this.pageTitleService.setTitle(client.company_name + ' | Contactpersoon aanpassen | ' + environment.webappName);
					this.pageTitleService.setPageTitle(client.company_name);
				}
			});

			this.previousUrlService.setPreviousUrlIfNull('/clients/' + this.client_id + '/view');

			this.loadData();
		});
		this._errorsSubscription = this.clientsService.errors.subscribe(errors => {
			this.formsService.processErrors(errors);
		});
	}

	ngOnDestroy(): void {
		if (this._activatedRouteSubscription !== null) {
			this._activatedRouteSubscription.unsubscribe();
		}

		if (this._errorsSubscription !== null) {
			this._errorsSubscription.unsubscribe();
		}
	}

	loadData() {
		this.clientsService.getContactPerson(this.client_id, this.contact_person_id).then((contact_person: ClientsContactsPersons) => {
			if (typeof contact_person !== 'undefined') {
				this.formsService.populateForm(contact_person);

				this.dataLoaded = true;
			} else {
				this.missingData.push('Contactpersoon');
			}
		});
	}
}
